import {
    BulletinListExportExcelResponse
} from '../../../../infrastructure/remote/sacmi/dto/response/BulletinListExportExcelResponse';
import {BulletinRepository} from '../repository/BulletinRepository';
import {BulletinListFilters} from '../../view/useBulletinListFilters';

interface Props {
    bulletinRepository: BulletinRepository;
    bulletinIds: string[];
    filters: BulletinListFilters;
}

export default async (props: Props): Promise<BulletinListExportExcelResponse> => {
    try {
        return await props.bulletinRepository.exportExcel(props.bulletinIds, props.filters);
    } catch (error) {
        return Promise.reject(error);
    }
}
